export interface PricingSupplement {
  tradeId: string;
  ezShareDocumentId: string;
  internalLink: string;
  publicLink: string;
  fileName: string | null;
  createdBy: string | null;
  dateCreated: string | null;
  modifiedBy: string | null;
  dateModified: string | null;
}

export interface PricingSupplementLinkRequest {
  ezShareDocumentId: string;
}

export interface PricingSupplementMissingField {
  field: string;
  label: string;
}

/** GET /PricingSupplement/trade/{tradeId}: upload eligibility plus the current document (null when none). */
export interface PricingSupplementStatus {
  tradeId: string;
  hasPricingSupplement: boolean;
  canUploadPricingSupplement: boolean;
  missingFields: PricingSupplementMissingField[];
  message: string | null;
  pricingSupplement: PricingSupplement | null;
}

/** Only PDFs are allowed; browsers may report an empty MIME type, so the extension is authoritative. */
export function isPdfFile(file: File): boolean {
  const hasPdfExtension = /\.pdf$/i.test(file.name.trim());
  const type = (file.type ?? '').toLowerCase();
  return hasPdfExtension && (type === '' || type === 'application/pdf');
}
